// extracted by css-extract-rspack-plugin
var _1 = "YcSspU2P8EKGjBgA";
var _2 = "YuMMwzy9oByfrxx2";
export { _1 as "link", _2 as "menuLi" }
// extracted by css-extract-rspack-plugin
var _1 = "YcSspU2P8EKGjBgA";
var _2 = "YuMMwzy9oByfrxx2";
export { _1 as "link", _2 as "menuLi" }
